import { PropsWithChildren, useMemo, useState } from "react";
import { SelectedDriversFilter, SelectedDriversFilterContext } from "./common";

export const SafetyDashboardSelectedDriversContext = ({
  children,
}: PropsWithChildren<{}>) => {
  const [selectedFilter, setSelectedFilter] = useState<SelectedDriversFilter>();
  const selectedFilterAccessor = useMemo(
    () => ({
      selectedFilter,
      setSelectedFilter: (value?: SelectedDriversFilter) =>
        setSelectedFilter((x) => (x === value ? undefined : value)),
    }),
    [selectedFilter]
  );

  return (
    <SelectedDriversFilterContext.Provider value={selectedFilterAccessor}>
      {children}
    </SelectedDriversFilterContext.Provider>
  );
};
